import { httpApi } from '@api/http.api';
import type {
    CommonTablePaginatedResponse,
    CommonTableRequest,
} from '@routes/sidebar/admin-center/___shared___/types.ts';

export type EntityLocationRequest = CommonTableRequest;

export interface EntityLocation {
    id: number;

    name: string | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    stateCountyProvince: string | null;
    zipCode: string | null;
    countryId: number | null;
    countryName: string | null;

    isActive: boolean;
    isBuiltIn: boolean;
    createdAtUTC: string;
    updatedAtUTC: string;
}

export interface ResultsDescription {
    [k: string]: unknown;
}

export interface EntityLocationResponse {
    data: EntityLocation[];
    pagination: CommonTablePaginatedResponse;
    resultsDescription: ResultsDescription;
}

export interface CreateEntityLocationRequest {
    name: string;
    address1: string | null;
    address2: string | null;
    city: string | null;
    stateCountyProvince: string | null;
    zipCode: string | null;
    countryId: number | null;
}

export type UpdateEntityLocationRequest = CreateEntityLocationRequest;

export const getApiEntityLocation = (
    clientId: number,
    tenantAlias: string,
    payload: EntityLocationRequest,
): Promise<EntityLocationResponse> =>
    httpApi
        .post<EntityLocationResponse>(
            `admin-center/clients/${clientId}/tenants/${tenantAlias}/entity-locations/search`,
            payload,
        )
        .then(({ data }) => data);

export const createApiEntityLocation = (
    clientId: number,
    tenantAlias: string,
    payload: CreateEntityLocationRequest,
): Promise<EntityLocation> =>
    httpApi
        .post<EntityLocation>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/entity-locations`, payload)
        .then(({ data }) => data);

export const updateApiEntityLocation = (
    clientId: number,
    tenantAlias: string,
    id: number,
    payload: UpdateEntityLocationRequest,
): Promise<EntityLocation> =>
    httpApi
        .put<EntityLocation>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/entity-locations/${id}`, payload)
        .then(({ data }) => data);

export const deleteApiEntityLocation = (clientId: number, tenantAlias: string, id: number): Promise<EntityLocation> =>
    httpApi
        .delete<EntityLocation>(`admin-center/clients/${clientId}/tenants/${tenantAlias}/entity-locations/${id}`)
        .then(({ data }) => data);
